/** Limits from the backend video_to_gif tool — keep in sync with packages/agents video-to-gif.ts */
// biome-ignore lint/style/noMagicNumbers: 500 * 1024 * 1024 is the idiomatic way to express 500 MB
export const VIDEO_TO_GIF_MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024;
export const VIDEO_TO_GIF_MAX_DURATION_SECONDS = 30;
